import {Injectable, inject} from '@angular/core'
import {FirebaseMessaging} from '@capacitor-firebase/messaging'
import {InfoService} from '@services/info.service'

@Injectable({
  providedIn: 'root',
})
export class BadgeNotificationService {
  readonly #infoService = inject(InfoService)

  async updateBadgeNumber() {
    const badge = await this.getBadgeNumber()
    if (badge > 0) {
      this.clearBadgeNumber()
    }
  }

  clearBadgeNumber() {
    if (this.#infoService.isWeb()) {
      return
    }
    FirebaseMessaging.removeAllDeliveredNotifications().then()
  }

  private async getBadgeNumber(): Promise<number> {
    if (this.#infoService.isWeb()) {
      return Promise.resolve(0)
    }
    const notifications = await FirebaseMessaging.getDeliveredNotifications()
    return notifications?.notifications?.length
  }
}
